import { ProductTypeEnum } from "@kanpla/api-contract";

import { type Product } from "~/api/products/types";
import { type BasketItem } from "~/stores/kiosk-session/types";

export type UnlistedBasketChoice = {
  product_id: string;
  option_id: string;
  choice_id: string;
};

type FindUnlistedBasketChoicesArgs = {
  basket: BasketItem[];
  products: Product[];
};

/**
 * Picked choices that the catalog does not list under their option. The
 * basket prices, declares and shows nothing for them, so the sale differs from
 * what the guest picked. A line whose product is not listed at all is left
 * out: the basket already reports that case on its own.
 */
export function findUnlistedBasketChoices({
  basket,
  products
}: FindUnlistedBasketChoicesArgs): UnlistedBasketChoice[] {
  return basket.flatMap((item) => {
    if (item.type !== "variant") return [];

    const listed = products.find(
      (candidate) => candidate.id === item.productId
    );
    if (!listed || listed.type !== ProductTypeEnum.VARIANTS) return [];

    return item.choices.flatMap((choice) => {
      if (choice.quantity <= 0) return [];

      const found = listed.options
        .find((option) => option.id === choice.variantId)
        ?.choices.some((candidate) => candidate.id === choice.id);

      return found
        ? []
        : [
            {
              product_id: item.productId,
              option_id: choice.variantId,
              choice_id: choice.id
            }
          ];
    });
  });
}
